import React, { useState, useCallback } from 'react';
import Image from '@plone/volto/components/theme/Image/Image';
import cx from 'classnames';

import { PlayIcon } from '../../../../../components/SiteChrome/icons';

const VideoEmbed = (props) => {
  const {
    aspectRatio = '16:9',
    autoplay,
    brandedUI = false,
    className,
    color = '#444444',
    hd = true,
    id,
    placeholder,
    source,
    title,
    url,
    copyright,
    isEditMode,
  } = props;

  const [isActive, setIsActive] = useState(false);
  const PlayVideo = useCallback(() => {
    setIsActive(true);
  }, []);

  const getSrc = useCallback(() => {
    if (source === 'youtube') {
      return [
        url || `https://www.youtube-nocookie.com/embed/${id}`,
        `${url?.includes('?') ? '&' : '?'}autohide=true`,
        `&autoplay=${isActive || autoplay ? 1 : 0}`,
        `&mute=${autoplay ? 1 : 0}`,
        `&color=${encodeURIComponent(color)}`,
        `&hq=${hd}`,
        '&jsapi=false',
        `&modestbranding=${brandedUI}`,
        `&rel=${brandedUI ? 0 : 1}`,
      ].join('');
    }

    if (source === 'vimeo') {
      return [
        `https://player.vimeo.com/video/${id}`,
        '?api=false',
        `&autoplay=${isActive || autoplay ? 1 : 0}`,
        `&muted=${autoplay ? 1 : 0}`,
        `&byline=false`,
        `&color=${encodeURIComponent(color)}`,
        `&portrait=false`,
        `&title=false`,
      ].join('');
    }

    if (source === 'peertube') {
      return [
        `${url}`,
        `?autoplay=${isActive || autoplay ? 1 : 0}`,
        `&muted=${autoplay ? 1 : 0}`,
      ].join('');
    }

    return '';
  }, [source, id, isActive, autoplay, color, hd, brandedUI, url]);

  return (
    <div className={cx('ui embed video-embed', aspectRatio, className)}>
      {!isEditMode && (isActive || autoplay) ? (
        <iframe
          allowFullScreen
          frameBorder="0"
          height="100%"
          scrolling="no"
          src={getSrc()}
          title={title || `Embedded content from ${source}.`}
          width="100%"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        />
      ) : (
        <>
          {placeholder ? (
            <Image
              className="placeholder"
              src={placeholder}
              alt=""
              loading="lazy"
              onError={(event) => {
                if (event.currentTarget.src.endsWith('/maxresdefault.jpg')) {
                  event.currentTarget.src = event.currentTarget.src.replace(
                    '/maxresdefault.jpg',
                    '/hqdefault.jpg',
                  );
                }
              }}
            />
          ) : (
            <div className="fallback-placeholder"></div>
          )}
          <button
            type="button"
            className="video-play-button"
            onClick={PlayVideo}
            disabled={isEditMode}
            aria-label={title ? `Play video ${title}` : 'Play video'}
          >
            <span className="bonn-video-play-icon">
              <PlayIcon size={36} />
            </span>
          </button>
          {copyright && (
            <small className="bonn-image-copyright">© {copyright}</small>
          )}
        </>
      )}
    </div>
  );
};

export default VideoEmbed;
